import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { allProjects } from '../data/projectsData';
import './ProjectNextFooter.css';

// allProjects doesn't carry a short display name (company is null for
// several projects, and title is a full sentence-length case-study
// title) — this is the only place that needs one, so it's kept local
// rather than growing the shared Project interface for one consumer.
const SHORT_NAME: Record<string, string> = {
  '/projects/tmf': 'Toyota Mobility Foundation',
  '/projects/tothemoon': 'tothemoon',
  '/projects/cache': 'Cache',
  '/projects/nfl': 'NFL Big Data Bowl',
  '/projects/agrico': 'Agrico',
  '/projects/outlook': 'Outlook',
  '/projects/wayfinding': 'Wayfinding',
  '/projects/cairn': 'Cairn',
  '/projects/drift': 'Drift',
  '/projects/cragtech': 'CragTech',
};

const projectRoutes = allProjects
  .map((p) => p.route)
  .filter((route): route is string => Boolean(route));

// Sits at the bottom of every individual project page in place of the
// old site-wide Footer (contact CTA, clock, etc.) — that footer was
// built for the general site, not this back-button-only project-detail
// flow the redesign moved to. Cycles to the next project in
// projectsData's order, wrapping back to the first after the last.
const ProjectNextFooter: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // /projects/tmf/full and /projects/tmf/short both still "belong" to
  // tmf for next-project purposes — match on the first two path segments.
  const baseRoute = '/' + location.pathname.split('/').filter(Boolean).slice(0, 2).join('/');
  const currentIndex = projectRoutes.indexOf(baseRoute);
  const nextRoute = currentIndex === -1
    ? projectRoutes[0]
    : projectRoutes[(currentIndex + 1) % projectRoutes.length];
  const nextName = SHORT_NAME[nextRoute] || 'the next project';

  const goBack = () => navigate('/', { state: { openWork: true } });
  const goNext = () => navigate(nextRoute);

  return (
    <div className="project-next-footer">
      <p className="project-next-copy">
        <button className="project-next-back-link" onClick={goBack}>Back to work</button> for the rest.
      </p>
      <button className="project-next-link" onClick={goNext}>
        Check out {nextName} next <span aria-hidden>→</span>
      </button>
    </div>
  );
};

export default ProjectNextFooter;
